import { atom } from "jotai";

import { BookingWizard } from "../../../types";
import { BookingWizardDataAtom } from "../../stores";

export const setCourseLayoutAtom = atom(
  null,
  (get, set, courseLayout: BookingWizard.CourseLayout) => {
    const bookingWizardData = get(BookingWizardDataAtom);
    if (!bookingWizardData) {
      //@TODO: this is an error
      return;
    }

    if (bookingWizardData.type === "GolfBooking") {
      const newBookingWizardData: BookingWizard.BookingWizardData = {
        ...bookingWizardData,
        courseLayout,
      };
      set(BookingWizardDataAtom, newBookingWizardData);
    }
  }
);
